import Proj1 from "../assets/certificate/unstop.jpg";
import Proj2 from "../assets/certificate/accenture.png";
import Proj3 from "../assets/certificate/educba.jpeg";
import Proj4 from "../assets/certificate/google.webp";
import Proj5 from "../assets/certificate/tcs.jpg";
import Proj6 from "../assets/certificate/upgrad.jpg";
import Proj7 from "../assets/certificate/mvj.webp";

export const CertificateList = [
  {
    name: "Certificate of Participation in Level 1: E-Commerce ",
    image: Proj1,
    company:"Unstop, Flipkart"
  },
  {
    name: "Accenture Developer Program",
    image: Proj2,
    company: "Accenture",
  },
  {
    name: "Build Responsive Website using HTML , CSS , Bootstrap And Java",
    image: Proj3,
    company: "EDUCBA",
  },
  {
    name: "Fundamentals Of Digital Marketing",
    image: Proj4,
    company: "Google",
  },
  {
    name: "Knockdown the Lockdown",
    image: Proj5,
    company: "TCS iON",
  },
  {
    name: "Startup india Learning Program",
    image: Proj6,
    company: "upGrad",
  },
  {
    name: "Virtual Aavishkar 2020",
    image: Proj7,
    company: "Mvjce",
  },
];
